import React, { FC, ReactNode } from 'react';
import tw from 'twin.macro';

interface SidebarTabProps {
  tabs: {
    label: string;
    name: string;
    icon: ReactNode;
  }[];
  active: string | null;
  onChange: (e: React.MouseEvent, tab: string) => void;
}

const SidebarTab: FC<SidebarTabProps> = ({ tabs, active, onChange }) => {
  const activeIdx = tabs.findIndex((tab) => tab.name === active);
  return (
    <div
      css={(theme) => ({
        '@media (max-width: 1024px)': {
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: theme.colors.background,
          display: 'flex',
          justifyContent: 'center',
          overflow: 'auto',
        },
      })}
    >
      <div
        css={{
          overflow: 'hidden',
          position: 'relative',
          '@media (max-width: 1024px)': {
            display: 'flex',
            overflow: 'auto',
          },
        }}
      >
        
        {tabs.map((tab, idx) => (
          <div
            key={idx}
            css={(theme) => ({
              color: idx === activeIdx ? theme.colors.primary : '#6A6A6A',
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              flexShrink: 0,
              padding: '0 2px',
              height: 71,
              width: 71,
              cursor: 'pointer',
              ...tw`hover:text-black dark:hover:text-white`,
            })}
            onClick={(e) => onChange(e, tab.name)}
          >
            <div
              css={(theme) => ({
                fontSize: 24,
              })}
            >
              {tab.icon}
            </div>
            <span
              css={(theme) => ({ fontSize: 11, fontWeight: 600, marginTop: 3 })}
            >
              {tab.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SidebarTab;
